import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Contact = () => {
  return (
    <section id="contact" className="py-24 md:py-40 bg-surface">
      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
        <motion.div
           initial={{ opacity: 0, y: 20 }}
           whileInView={{ opacity: 1, y: 0 }}
           viewport={{ once: true }}
        >
          <h2 className="text-[0.65rem] md:text-xs font-sans tracking-[0.6em] text-accent uppercase font-bold mb-6 md:mb-10">Get in touch</h2>
          <h3 className="text-5xl md:text-8xl lg:text-9xl font-serif text-primary mb-10 md:mb-16 leading-none">Let's go.</h3>
          
          <div className="flex flex-col items-center gap-8 md:gap-12">
            <a 
              href="tel:2699106622" 
              className="text-3xl md:text-6xl lg:text-7xl font-serif text-text-main hover:text-accent transition-all duration-500 group flex flex-col items-center"
            >
              269-910-6622
              <span className="text-[0.6rem] md:text-sm font-sans tracking-[0.3em] uppercase text-text-muted font-bold mt-3 md:mt-4 group-hover:text-primary">Text or call for a ride</span>
            </a>
            
            <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-8 mt-2 md:mt-4">
              <a 
                href="https://instagram.com/southhavenrideshare"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 md:gap-4 text-[0.65rem] md:text-xs tracking-[0.2em] uppercase font-bold text-primary hover:text-accent transition-colors"
              >
                <SafeIcon icon={FiIcons.FiInstagram} className="text-lg md:text-xl" />
                @southhavenrideshare
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;